import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchInput, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { useGetDocumentsByIds } from 'src/hooks/documents/get-documents-by-ids.hook';
import { DocumentsListTable } from 'src/pages/employee/sub-pages/employee-details/employee-details-tabs/employee-documents/components/documents-list-table';

import { HeaderContainer, MainWrapper, StyledExpandableTable } from './employee-documents.styles';

const EmployeeDocuments = ({
  documentsIds,
  employeeId,
}: {
  documentsIds: string[];
  employeeId: string;
}) => {
  const { t } = useTranslation('settings');
  const [searchFieldValue, setSearchFieldValue] = useState('');

  const { documents, loading } = useGetDocumentsByIds(documentsIds, searchFieldValue, true);

  return (
    <MainWrapper>
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('documents.labels.documents')}
        </Typography>
        <div>
          <SearchInput onChange={e => setSearchFieldValue(e.target.value)} />
        </div>
      </HeaderContainer>
      <StyledExpandableTable
        loading={loading}
        dataSource={documents.filter((doc: any) => doc.documentTemplates.length)}
        expandedRowRender={document => (
          <DocumentsListTable
            data={document.documentTemplates}
            documentId={document._id}
            employeeId={employeeId}
            isOwnData
          />
        )}
      >
        <StyledExpandableTable.Column
          title={t('documentsLabels.labels')}
          sorter={(a: any, b: any) => a.documentLabel.name.localeCompare(b.documentLabel.name)}
          render={document => <Typography>{document?.documentLabel?.name}</Typography>}
        />
      </StyledExpandableTable>
    </MainWrapper>
  );
};

export default EmployeeDocuments;
